import { Metadata } from 'nice-grpc-web';
import { Middleware } from 'redux';
import { AppDispatch, RootState } from '../store';

import { MarginDownstreamEvent } from '@/compiled_proto/com/celertech/positionmanager/api/margin/DownstreamMarginProto';
import { forEachAsync } from '@/helpers/asyncIterableHelper';
import { positionManagerClient } from '@/helpers/environmentHelper';
import { Logger } from '@/utils/logger';
import { v4 as uuidv4 } from 'uuid';
import { AccountUsage, setAccountUsage } from '../reducers/accountUsageSlice';
import { controlClearSubscriptions, controlInitSubscriptions, User } from '../reducers/authSlice';

let subscriptionId: any = null;
let accountUsagesSubscription: any = null;
let abortController = new AbortController();

const parseAccountUsageEvent = (accountUsageEvent: MarginDownstreamEvent): AccountUsage => ({
    account: accountUsageEvent.account,
    usage: accountUsageEvent.usage,
    accountValue: accountUsageEvent.accountValue,
    unrealisedPnl: accountUsageEvent.unrealisedPnl,
    currency: accountUsageEvent.currency
});

const setupAccountUsageSubscription = async (store: any, dispatch: AppDispatch, credentials: User) => {
    // Subscribe for changes to accountUsages
    accountUsagesSubscription = positionManagerClient.ws.subscribeForAccountUsage(
        // subscribes to all accounts under the user, further optimization can be done to scope down subscribed events.
        { accountCode: credentials.accounts.map((account) => account.code) },
        {
            metadata: Metadata({
                'authorization-token': credentials.authToken
            }),
            signal: abortController.signal
        }
    );

    const currentSubscriptionId = uuidv4();
    subscriptionId = currentSubscriptionId;
    forEachAsync(
        accountUsagesSubscription,
        (accountUsageUpdate: { event: MarginDownstreamEvent; isHeartBeat: boolean }) => {
            if (accountUsageUpdate?.event && !accountUsageUpdate.isHeartBeat) {
                // Logger({
                //     title: 'Inbound: AccountUsageMiddleware event',
                //     callback: () => console.log(accountUsageUpdate.event)
                // });
                dispatch(setAccountUsage(parseAccountUsageEvent(accountUsageUpdate.event)));
            }
        },
        abortController,
        `AccountUsageMiddleware`
    )

    // Fetch latest accountUsage on init
    // await dispatch(changeBalanceAccount({ credentials }));
};

const AccountUsageMiddleware: Middleware = (store) => (next) => (action) => {
    if (controlClearSubscriptions.match(action)) {
        abortController.abort();
        subscriptionId = null;
        accountUsagesSubscription = null;
    } else if (controlInitSubscriptions.match(action)) {
        Logger({ title: `AccountUsageMiddleware: Initialise Subscriptions`, callback: () => {} });

        const dispatch: AppDispatch = store.dispatch;
        const state: RootState = store.getState();
        const creds = state.auth.user;
        // If not already listening, setup subscriptions
        if (!accountUsagesSubscription && creds) {
            abortController = new AbortController();
            setupAccountUsageSubscription(store, dispatch, creds);
        }
    }

    // Pass on to next middlewares in line
    next(action);
};

export default AccountUsageMiddleware;
